<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data" class="body">
      小队编号:{{ formData.teamId }}
      <br>
      小队编码:{{ formData.code }}
      <br>
      用户身份:{{ formData.token }}
      <br>
      <div v-if="data.type=='SUCCESS'" class="info success">
        {{ data.body }}
      </div>
      <div v-if="data.type=='ERROR'" class="info error">
        {{ data.body }}
      </div>
      <div v-if="data.type=='WARNING'" class="info warning">
        {{ data.body }}
      </div>
      <div v-if="data.time" class="info">
        领取时间:{{ formatDate(data.time,"yyyy-MM-dd hh:mm:ss",true) }}
      </div>
    </div>
  </div></template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate } from '@/utils/base'
import { Button } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      title: '奖励领取判定',
      backurl: '/users/index',
      teamId: undefined,
      data: undefined,
      formData: {
        teamId: undefined,
        code: undefined,
        token: undefined
      }
    }
  },

  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.formData.teamId = getUrlKey('teamId')
    this.formData.code = getUrlKey('code')
    this.formData.token = getUrlKey('token')
    request({
      url: '/Activity/CheckGiftQrCode',
      method: 'post',
      data: this.formData
    }).then(Response => {
      if (!Response.success) {
        this.data.type = 'ERROR'
        this.data.body = '请求异常'
        return
      }
      this.data = Response.data
    })
  },
  methods: {
    formatDate
  }
}
</script>
<style scoped>
.body{
    padding: 1em;
    word-wrap:break-word;
}
.info{
    font-size: 2em;
}
.success{
    color: rgb(85, 255, 51);
    font-weight: 700;
      font-size: 3em;
}
.error{
     color: rgb(255, 51, 51);
      font-weight: 700;
        font-size: 3em;
}
.warning{
     color: rgb(255, 157, 10);
      font-weight: 700;
        font-size: 3em;
}
</style>
